import { clsx } from 'clsx';

interface BurgerBarProps {
  isOpen?: boolean;
  isPlaceholder?: boolean;
  position: 'top' | 'middle' | 'bottom';
}

export const BurgerBar = ({
  isOpen,
  isPlaceholder,
  position,
}: BurgerBarProps) => {
  const baseClasses =
    'burger-bar absolute left-1/2 top-1/2 h-px w-7 translate-x-[-50%] duration-500 ease-[ease] sm:w-[22px] pointer-events-none';

  const positionClasses = {
    top: isOpen
      ? 'translate-y-[-50%] rotate-45 bg-white'
      : 'translate-y-[calc(-50%-9px)] sm:translate-y-[calc(-50%-7px)]',
    middle: isOpen
      ? 'translate-x-[calc(-50%-20px)] translate-y-[-50%] bg-white opacity-0'
      : 'translate-x-[-50%] translate-y-[-50%] opacity-100',
    bottom: isOpen
      ? 'translate-y-[-50%] -rotate-45 bg-white'
      : 'translate-y-[calc(-50%+9px)] sm:translate-y-[calc(-50%+7px)]',
  };

  const classes = clsx(
    baseClasses,
    positionClasses[position],
    isPlaceholder ? 'bg-white' : 'bg-black-500'
  );

  return <span className={classes} />;
};
